import { TShare } from '../share.model';
import { EUserRole } from './user-roles';

export function canCreatePoint(shareOption: string): boolean {
  return (
    shareOption === EUserRole.SITE_ADMIN ||
    shareOption === EUserRole.NORMAL ||
    shareOption === EUserRole.OWNER ||
    shareOption === EUserRole.ACCOUNT_ADMIN
  );
}

export function canEditPoint(shareOption: string): boolean {
  return (
    shareOption === EUserRole.SITE_ADMIN ||
    shareOption === EUserRole.NORMAL ||
    shareOption === EUserRole.OWNER ||
    shareOption === EUserRole.ACCOUNT_ADMIN
  );
}

export function canEditFlag(share: TShare): boolean {
  return (
    share?.shareOption === EUserRole.SITE_ADMIN ||
    share?.shareOption === EUserRole.OWNER ||
    share?.shareOption === EUserRole.ACCOUNT_ADMIN ||
    share?.advancedAccessLevels?.flags?.permission?.edit
  );
}

export function canDeletePoint(shareOption: string): boolean {
  return (
    shareOption === EUserRole.SITE_ADMIN ||
    shareOption === EUserRole.OWNER ||
    shareOption === EUserRole.ACCOUNT_ADMIN
  );
}
